import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
// import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { routes } from '../routes/routes-names';
import PageLoader from '../../components/loader';
import AuthSocial from '../registration/social';
import { authService } from '../../lib/api/auth';
import { useAppSelector } from '../../redux/hooks';



const Main: React.FC = () => {
    const location = useLocation();
    const navigate= useNavigate();
    const { ConfirmAdminInvitationId } = queryString.parse(location.search);
    const { loading, user } = useAppSelector((state) => state.user);

    useEffect(() => {
        if (loading || !user) return;

        navigate(routes.companyList);
    }, [loading, user]);

    return loading ? (
        <PageLoader />
    ) : (
        <AuthSocial
            invitationId={typeof ConfirmAdminInvitationId === 'string' ? ConfirmAdminInvitationId : undefined}
        />
    );
};

export default Main;
